<template>
    <el-dialog :visible.sync="showDialogProxy" :close-on-click-modal="false" :append-to-body="true" width="1180px"
        top="2vh" custom-class="pos-payment-dialog" title="Cobro">

        <div v-loading="loading_submit" class="payment-modal-content row col-lg-12 m-0 p-0">
            <div class="col-lg-7 col-md-7 px-3 pt-1 payment-shell">
                <div class="row pt-1">
                    <div class="col-lg-7 col-md-6">
                        <el-radio-group v-model="form.document_type_id" size="small" @change="filterSeries">
                            <el-radio-button label="01">FACTURA</el-radio-button>
                            <el-radio-button label="03">BOLETA</el-radio-button>
                            <el-radio-button label="80">N. VENTA</el-radio-button>
                        </el-radio-group>
                    </div>

                    <div class="col-lg-5 col-md-6">
                        <div class="d-flex justify-content-end align-items-center top-actions">
                            <el-select v-model="form.series_id" class="c-width c-width-series mr-2">
                                <el-option v-for="option in series" :key="option.id" :label="option.number"
                                    :value="option.id">
                                </el-option>
                            </el-select>

                            <button class="btn btn-sm btn-primary btn-back-small" @click="close">
                                <i class="fas fa-angle-left"></i> Regresar
                            </button>
                        </div>
                    </div>

                    <div class="col-lg-12 payment-main-col mt-2">
                        <div class="row">
                            <div class="col-lg-6">
                                <label class="control-label">
                                    <i class="far fa-credit-card mr-2"></i>Condición de pago
                                </label>
                                <el-radio-group v-model="paymentCondition" size="small"
                                    @change="changePaymentCondition">
                                    <el-radio-button label="cash">Contado</el-radio-button>
                                    <el-radio-button label="credit">Crédito</el-radio-button>
                                </el-radio-group>
                            </div>

                            <div class="col-lg-6" v-if="paymentCondition === 'cash'">
                                <label class="control-label">
                                    <i class="fas fa-wallet mr-2"></i>Forma de cobro
                                </label>
                                <el-radio-group v-model="paymentMode" size="small" @change="changePaymentMode">
                                    <el-radio-button label="simple">Efectivo</el-radio-button>
                                    <el-radio-button label="mixed">Mixto</el-radio-button>
                                </el-radio-group>
                            </div>

                            <div class="col-lg-6" v-if="paymentCondition === 'credit'">
                                <label class="control-label">
                                    <i class="fas fa-credit-card mr-2"></i>Tipo de crédito
                                </label>
                                <el-radio-group v-model="creditMode" size="small" @change="changeCreditMode">
                                    <el-radio-button label="single">Plazo fijo</el-radio-button>
                                    <el-radio-button label="installments">Crédito en cuotas</el-radio-button>
                                </el-radio-group>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-12 payment-main-col mt-2">
                        <div class="card card-default">
                            <div class="card-body text-center">
                                <p class="my-0"><small>Monto a cobrar</small></p>
                                <h1 class="mb-2 mt-0 amount-main">S/ {{ totalToPay }}</h1>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-12 payment-main-col">
                        <div class="card card-default">
                            <div class="card-body text-center">
                                <div class="row col-lg-12">
                                    <div class="col-lg-6">
                                        <div class="form-group">
                                            <label class="control-label">Ingrese monto</label>
                                            <el-input ref="enter_amount" v-model="enter_amount" @input="enterAmount">
                                                <template slot="prepend">S/</template>
                                            </el-input>
                                        </div>
                                    </div>

                                    <div class="col-lg-6">
                                        <div :class="{ 'has-danger': difference < 0 }" class="form-group">
                                            <label class="control-label"
                                                v-text="difference < 0 ? 'Faltante' : 'Vuelto'"></label>
                                            <h4 class="control-label font-weight-semibold m-0 text-center m-b-0">
                                                S/ {{ differenceText }}
                                            </h4>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-12 payment-main-col">
                        <div class="card card-default">
                            <div class="card-body text-center">
                                <div class="row col-lg-12">
                                    <div class="col-lg-6">
                                        <div class="form-group">
                                            <h2>
                                                <el-switch v-model="enabled_discount" active-text="Aplicar descuento"
                                                    class="control-label font-weight-semibold m-0 text-center m-b-0"
                                                    @change="changeEnabledDiscount">
                                                </el-switch>
                                            </h2>
                                        </div>
                                    </div>

                                    <div class="col-lg-6">
                                        <div class="form-group">
                                            <label class="control-label">
                                                <el-checkbox v-model="is_discount_amount"
                                                    class="ml-1 mr-1"></el-checkbox>
                                                <template>{{ is_discount_amount ? 'Monto' : 'Porcentaje' }}
                                                    descuento</template>
                                                <i class="fa fa-info-circle"></i>
                                            </label>

                                            <el-input v-model="discount_amount" :disabled="!enabled_discount"
                                                @change="inputDiscountAmount">
                                                <template slot="prepend" v-if="is_discount_amount">S/</template>
                                                <template slot="append" v-else>%</template>
                                            </el-input>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-12 payment-main-col" v-if="paymentCondition === 'credit'">
                        <div class="card card-default">
                            <div class="card-body">
                                <div class="row col-lg-12">
                                    <div class="col-lg-4" v-if="creditMode === 'single'">
                                        <div class="form-group">
                                            <label class="control-label">Método de pago</label>
                                            <el-select v-model="creditPaymentMethodTypeId" class="w-100"
                                                @change="syncCreditFees">
                                                <el-option v-for="option in creditPaymentMethods" :key="option.id"
                                                    :value="option.id" :label="option.description">
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </div>

                                    <div class="col-lg-4" v-if="creditMode === 'single'">
                                        <div class="form-group">
                                            <label class="control-label">Fecha de vencimiento</label>
                                            <el-date-picker v-model="creditDueDate" type="date"
                                                value-format="yyyy-MM-dd" format="dd/MM/yyyy" class="w-100"
                                                @change="syncCreditFees">
                                            </el-date-picker>
                                        </div>
                                    </div>

                                    <div class="col-lg-4" v-if="creditMode === 'single'">
                                        <div class="form-group">
                                            <label class="control-label">Monto</label>
                                            <el-input v-model="creditAmount" disabled>
                                                <template slot="prepend">S/</template>
                                            </el-input>
                                        </div>
                                    </div>

                                    <div class="col-lg-12" v-if="creditMode === 'installments'">
                                        <div class="d-flex justify-content-between align-items-center mb-2">
                                            <label class="control-label m-0">Cuotas</label>
                                            <button class="btn btn-sm btn-primary" @click.prevent="addCreditFee">
                                                <i class="fas fa-plus"></i> Agregar cuota
                                            </button>
                                        </div>

                                        <div class="table-responsive">
                                            <table class="table table-sm">
                                                <thead>
                                                    <tr>
                                                        <th>Fecha</th>
                                                        <th>Monto</th>
                                                        <th width="70"></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(fee, index) in form.fee" :key="index">
                                                        <td>
                                                            <el-date-picker v-model="fee.date" type="date"
                                                                value-format="yyyy-MM-dd" format="dd/MM/yyyy"
                                                                class="w-100">
                                                            </el-date-picker>
                                                        </td>
                                                        <td>
                                                            <el-input v-model="fee.amount">
                                                                <template slot="prepend">S/</template>
                                                            </el-input>
                                                        </td>
                                                        <td class="text-center">
                                                            <button class="btn btn-xs btn-danger"
                                                                @click.prevent="removeCreditFee(index)">
                                                                <i class="fa fa-trash"></i>
                                                            </button>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-12 payment-main-col" v-if="paymentCondition === 'cash'">
                        <div class="card card-default">
                            <div class="card-body">
                                <div class="input-group mb-3">
                                    <div class="col-lg-12 m-bottom">
                                        <div class="row align-items-center">
                                            <div class="col-lg-6">
                                                <h5><strong>Pagos agregados </strong></h5>
                                            </div>

                                            <div class="col-lg-1"></div>

                                            <div class="col-lg-5">
                                                <button class="btn btn-sm btn-block btn-primary"
                                                    @click="showDialogMultiplePayment = true">
                                                    <i class="fas fa-edit"></i> Modificar pagos
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-lg-12 m-bottom">
                                        <div class="row align-items-center">
                                            <template v-for="(pay, index) in form.payments">
                                                <div :key="'n-' + index" class="col-lg-1">
                                                    <label>{{ index + 1 }}.-</label>
                                                </div>

                                                <div :key="'m-' + index" class="col-lg-6">
                                                    <label>{{
                                                        getDescriptionPaymentMethodType(pay.payment_method_type_id)
                                                        }}</label>
                                                </div>

                                                <div :key="'p-' + index" class="col-lg-5">
                                                    <label>
                                                        <strong>S/ {{ Number(pay.payment || 0).toFixed(2) }}</strong>
                                                    </label>
                                                </div>
                                            </template>
                                        </div>
                                    </div>

                                    <div v-if="form_payment.payment_method_type_id == '01'" class="col-lg-12">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <button class="btn btn-block btn-light quick-cash-btn"
                                                    @click="setAmountCash(10)">
                                                    S/10
                                                </button>
                                            </div>
                                            <div class="col-lg-3">
                                                <button class="btn btn-block btn-light quick-cash-btn"
                                                    @click="setAmountCash(20)">
                                                    S/20
                                                </button>
                                            </div>
                                            <div class="col-lg-3">
                                                <button class="btn btn-block btn-light quick-cash-btn"
                                                    @click="setAmountCash(50)">
                                                    S/50
                                                </button>
                                            </div>
                                            <div class="col-lg-3">
                                                <button class="btn btn-block btn-light quick-cash-btn"
                                                    @click="setAmountCash(100)">
                                                    S/100
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-12 payment-main-col" v-if="paymentCondition === 'cash'">
                        <div class="card card-default">
                            <div class="card-body">
                                <div class="row col-lg-12">
                                    <div class="col-md-12 col-lg-12">
                                        <div class="form-group">
                                            <label class="control-label">Datos de referencia</label>
                                            <el-input v-model="form.reference_data" maxlength="200" show-word-limit
                                                type="textarea">
                                            </el-input>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-12 payment-main-col mb-3 form-actions-bar">
                        <div class="row">
                            <div class="col-lg-6">
                                <button class="btn btn-block btn-outline-danger" @click="close">
                                    <i class="far fa-trash-alt mr-2"></i>Cancelar
                                </button>
                            </div>
                            <div class="col-lg-6">
                                <button class="btn btn-block btn-primary btn-confirm-pay" :disabled="isSubmitDisabled"
                                    @click="confirmPayment">
                                    <i class="fas fa-check mr-2"></i>Confirmar pago
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-5 col-md-5 px-3 pt-1 restaurant-summary-shell">
                <div class="restaurant-customer-box">
                    <el-select ref="select_person" v-model="form.customer_id" filterable placeholder="Cliente"
                        class="restaurant-customer-select" @change="changeCustomer" @keyup.native="keyupCustomer"
                        @keyup.enter.native="keyupEnterCustomer">
                        <el-option v-for="option in all_customers" :key="option.id" :label="option.description"
                            :value="option.id">
                        </el-option>
                    </el-select>

                    <button class="btn btn-sm btn-default restaurant-customer-button"
                        @click.prevent="showDialogNewPerson = true">
                        <i class="fas fa-plus"></i>
                    </button>

                    <button class="btn btn-sm btn-default restaurant-customer-button"
                        @click.prevent="clickDeleteCustomer">
                        <i class="fas fa-trash"></i>
                    </button>
                </div>
                <div class="current-order-card">
                    <div class="current-order-header">
                        <div>
                            <h4>Pedido actual</h4>
                            <span>Resumen para el comprobante</span>
                        </div>

                        <div class="current-order-icon">
                            <i class="fas fa-receipt"></i>
                        </div>
                    </div>

                    <div class="current-order-consumption">
                        <el-checkbox v-model="saleByConsumption">
                            Venta por consumo
                        </el-checkbox>
                    </div>

                    <div v-if="saleByConsumption" class="current-order-consumption-input">
                        <label>Descripción</label>
                        <el-input v-model="consumptionDescription" placeholder="POR CONSUMO">
                        </el-input>
                    </div>

                    <div v-else class="current-order-items">
                        <div v-for="row in groupedOrderItems" :key="row.group_key" class="current-order-item">

                            <div class="current-order-product">
                                <strong>
                                    {{ orderItemDescription(row) }}
                                </strong>
                                <span v-if="row.note">{{ row.note }}</span>
                                <small>{{ form.document_type_id === '01' || form.document_type_id === '03' ? 'S/' : 'S/'
                                    }} {{
                                        Number(row.total).toFixed(2) }}</small>
                            </div>

                            <div class="current-order-quantity">
                                x{{ Number(row.quantity).toFixed(0) }}
                            </div>
                        </div>
                    </div>

                    <div class="current-order-totals">
                        <div>
                            <span>Op. Gravadas</span>
                            <strong>S/ {{ totals.taxed }}</strong>
                        </div>

                        <div>
                            <span>Op. Exoneradas</span>
                            <strong>S/ {{ totals.exonerated }}</strong>
                        </div>

                        <div>
                            <span>Op. Inafectas</span>
                            <strong>S/ {{ totals.unaffected }}</strong>
                        </div>

                        <div>
                            <span>IGV</span>
                            <strong>S/ {{ totals.igv }}</strong>
                        </div>
                    </div>

                    <div class="current-order-grand-total">
                        <span>Total</span>
                        <strong>S/ {{ totalToPay }}</strong>
                    </div>
                </div>
            </div>
        </div>



        <el-dialog title="Pagos" :visible.sync="showDialogMultiplePayment" :append-to-body="true" width="760px">

            <div class="table-responsive">
                <table class="table table-sm">
                    <thead>
                        <tr>
                            <th>Método de pago</th>
                            <th>Destino</th>
                            <th>Referencia</th>
                            <th>Monto</th>
                            <th width="80">
                                <a href="#" @click.prevent="clickAddPayment">[+ Agregar]</a>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(row, index) in form.payments" :key="index">
                            <td>
                                <el-select v-model="row.payment_method_type_id" class="w-100">
                                    <el-option v-for="option in payment_method_types" :key="option.id"
                                        :value="option.id" :label="option.description">
                                    </el-option>
                                </el-select>
                            </td>

                            <td>
                                <el-select v-model="row.payment_destination_id" class="w-100">
                                    <el-option v-for="option in payment_destinations" :key="option.id"
                                        :value="option.id" :label="option.description">
                                    </el-option>
                                </el-select>
                            </td>

                            <td>
                                <el-input v-model="row.reference"></el-input>
                            </td>

                            <td>
                                <el-input v-model="row.payment" @input="calculateDifference"></el-input>
                            </td>

                            <td class="text-center">
                                <button class="btn btn-xs btn-danger" @click.prevent="removePayment(index)">
                                    <i class="fa fa-trash"></i>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <span slot="footer">
                <el-button @click="showDialogMultiplePayment = false">Cerrar</el-button>
            </span>
        </el-dialog>

        <person-form :showDialog.sync="showDialogNewPerson" type="customers" :input_person="input_person"
            :external="true" :document_type_id="form.document_type_id">
        </person-form>

    </el-dialog>
</template>

<script>
import moment from 'moment'
import PersonForm from '../../../../../../../../resources/js/views/tenant/persons/form.vue'

export default {
    components: {
        PersonForm,
    },
    props: ['showDialog', 'order'],
    data() {
        return {
            loading_submit: false,
            resource: 'restaurant/v2/orders',
            all_series: [],
            series: [],
            payment_method_types: [],
            paymentCondition: 'cash',
            paymentMode: 'simple',
            enabled_discount: false,
            is_discount_amount: true,
            discount_amount: 0,
            enter_amount: 0,
            difference: 0,
            form_payment: {
                payment_method_type_id: '01',
            },
            form: {
                document_type_id: '03',
                series_id: null,
                customer_id: null,
                reference_data: null,
                total: 0,
                payments: [],
                fee: [],
            },
            showDialogMultiplePayment: false,
            payment_destinations: [],
            saleByConsumption: false,
            consumptionDescription: 'POR CONSUMO',
            all_customers: [],
            customer: null,
            input_person: {},
            showDialogNewPerson: false,
            igv_percentage: 0.18,
            creditMode: 'single',
            creditPaymentMethodTypeId: null,
            creditDueDate: moment().format('YYYY-MM-DD'),
            creditAmount: 0,
        }
    },
    computed: {
        showDialogProxy: {
            get() {
                return this.showDialog
            },
            set(value) {
                this.$emit('update:showDialog', value)
            },
        },
        totalToPay() {
            return Number(this.form.total || 0).toFixed(2)
        },
        differenceText() {
            return Number(this.difference || 0).toFixed(2)
        },
        isSubmitDisabled() {
            if (this.paymentCondition === 'credit') return false
            return Number(this.difference) < 0
        },
        totals() {
            const total = Number(this.form.total || 0)
            const factor = 1 + Number(this.igv_percentage || 0.18)
            const taxed = total / factor

            return {
                taxed: taxed.toFixed(2),
                exonerated: '0.00',
                unaffected: '0.00',
                igv: (total - taxed).toFixed(2),
            }
        },
        creditPaymentMethods() {
            const excludedIds = ['08', '09']

            return this.payment_method_types.filter(row => {
                const isCredit = row.is_credit === true || row.is_credit === 1 || row.is_credit === '1'
                const id = String(row.id || '')

                return isCredit && !excludedIds.includes(id)
            })
        },
        groupedOrderItems() {
            const groups = []
            const grouped = {}

                ; (this.order.items || []).forEach(row => {
                    const presentation =
                        row.item_unit_type_id || 'base'

                    const area =
                        row.restaurant_production_area_id
                        || 'no_area'

                    const note = row.note || ''

                    const unitPrice =
                        Number(row.unit_price || 0)
                            .toFixed(6)

                    const key = [
                        row.item_id,
                        presentation,
                        area,
                        note,
                        unitPrice,
                    ].join('_')

                    if (!grouped[key]) {
                        grouped[key] = {
                            ...row,
                            group_key: `item_${key}`,
                            quantity: Number(row.quantity),
                            total: Number(row.total),
                        }

                        groups.push(grouped[key])
                    } else {
                        grouped[key].quantity +=
                            Number(row.quantity)

                        grouped[key].total +=
                            Number(row.total)
                    }
                })

            return groups
        },
    },
    watch: {
        showDialog(value) {
            if (value) {
                this.init()
            }
        },
    },
    mounted() {
        this.$eventHub.$on('reloadDataPersons', customer_id => {
            this.reloadDataCustomers(customer_id)
        })
    },
    methods: {
        init() {
            this.form.document_type_id = '03'
            this.form.reference_data = null
            this.form.total = Number(this.order.total || 0)
            this.paymentCondition = 'cash'
            this.paymentMode = 'simple'
            this.creditMode = 'single'
            this.creditPaymentMethodTypeId = null
            this.creditDueDate = moment().add(30, 'days').format('YYYY-MM-DD')
            this.creditAmount = this.form.total
            this.form.fee = []
            this.enabled_discount = false
            this.is_discount_amount = true
            this.discount_amount = 0
            this.enter_amount = this.form.total
            this.form.payments = []
            this.addDefaultPayment(this.form.total)
            this.calculateDifference()
            this.form.customer_id = this.order.customer_id ? Number(this.order.customer_id) : null
            this.customer = null
            this.getTables()
            this.saleByConsumption = false
            this.consumptionDescription = 'POR CONSUMO',
                this.igv_percentage = Number(this.order.igv_percentage || 0.18)
        },
        getTables() {
            this.$http.get('/pos/payment_tables').then(response => {
                this.all_series = response.data.series
                this.payment_method_types = response.data.payment_method_types
                this.payment_destinations = response.data.payment_destinations
                this.filterSeries()

                const existsCreditMethod = this.creditPaymentMethods.some(row => {
                    return String(row.id) === String(this.creditPaymentMethodTypeId)
                })

                if (!existsCreditMethod && this.creditPaymentMethods.length > 0) {
                    this.creditPaymentMethodTypeId = this.creditPaymentMethods[0].id
                }
            })

            this.$http.get('/pos/table/customers').then(response => {
                this.all_customers = response.data

                if (this.form.customer_id) {
                    const reservedCustomer = this.all_customers.find(row => {
                        return String(row.id) === String(this.form.customer_id)
                    })

                    if (reservedCustomer) {
                        this.form.customer_id = reservedCustomer.id
                        this.changeCustomer()
                        return
                    }
                }

                if (this.all_customers.length > 0) {
                    const defaultCustomer = this.all_customers.find(row => {
                        return String(row.description).includes('99999999')
                    })

                    this.form.customer_id = defaultCustomer ? defaultCustomer.id : this.all_customers[0].id
                    this.changeCustomer()
                }
            })
        },
        filterSeries() {
            const documentType = String(this.form.document_type_id).padStart(2, '0')
            this.series = this.all_series.filter(row => {
                return String(row.document_type_id).padStart(2, '0') === documentType
            })
            this.form.series_id = this.series.length > 0 ? this.series[0].id : null
        },
        changePaymentCondition() {
            this.form.payments = []
            this.form.fee = []

            if (this.paymentCondition === 'cash') {
                this.enter_amount = this.form.total
                this.addDefaultPayment(this.form.total)
            } else {
                this.enter_amount = 0
                this.creditAmount = this.form.total

                const existsCreditMethod = this.creditPaymentMethods.some(row => {
                    return String(row.id) === String(this.creditPaymentMethodTypeId)
                })

                if (!existsCreditMethod && this.creditPaymentMethods.length > 0) {
                    this.creditPaymentMethodTypeId = this.creditPaymentMethods[0].id
                }

                this.syncCreditFees()
            }

            this.calculateDifference()
        },
        changePaymentMode() {
            this.form.payments = []
            this.enter_amount = this.form.total
            this.addDefaultPayment(this.form.total)
            this.calculateDifference()
        },
        addDefaultPayment(amount) {
            this.form.payments.push({
                date_of_payment: moment().format('YYYY-MM-DD'),
                payment_method_type_id: '01',
                payment_destination_id: 'cash',
                reference: null,
                payment: Number(amount || 0).toFixed(2),
            })
        },
        clickAddPayment() {
            this.form.payments.push({
                date_of_payment: moment().format('YYYY-MM-DD'),
                payment_method_type_id: '01',
                payment_destination_id: 'cash',
                reference: null,
                payment: 0,
            })

            this.calculateDifference()
        },
        removePayment(index) {
            this.form.payments.splice(index, 1)
            this.calculateDifference()
        },
        changeCreditMode() {
            this.form.fee = []

            if (this.creditMode === 'installments') {
                this.addCreditFee()
            } else {
                this.syncCreditFees()
            }
        },

        syncCreditFees() {
            const existsCreditMethod = this.creditPaymentMethods.some(row => {
                return String(row.id) === String(this.creditPaymentMethodTypeId)
            })

            if (this.creditMode === 'single' && !existsCreditMethod && this.creditPaymentMethods.length > 0) {
                this.creditPaymentMethodTypeId = this.creditPaymentMethods[0].id
            }

            if (this.paymentCondition !== 'credit') return

            if (this.creditMode === 'single') {
                this.form.fee = [{
                    id: null,
                    date: this.creditDueDate,
                    currency_type_id: 'PEN',
                    amount: Number(this.form.total || 0).toFixed(2),
                    payment_method_type_id: this.creditPaymentMethodTypeId,
                }]
            }

            this.syncCreditDueDate()
        },

        addCreditFee() {
            if (!Array.isArray(this.form.fee)) {
                this.form.fee = []
            }

            this.form.fee.push({
                id: null,
                date: moment().add(this.form.fee.length + 1, 'months').format('YYYY-MM-DD'),
                currency_type_id: 'PEN',
                amount: Number(this.form.total || 0).toFixed(2),
                payment_method_type_id: null,
            })

            this.syncCreditDueDate()
        },

        removeCreditFee(index) {
            this.form.fee.splice(index, 1)

            if (this.form.fee.length === 0) {
                this.addCreditFee()
            }

            this.syncCreditDueDate()
        },
        syncCreditDueDate() {
            if (this.paymentCondition !== 'credit') return

            if (!this.form.fee || this.form.fee.length === 0) {
                this.creditDueDate = moment().format('YYYY-MM-DD')
                return
            }

            const lastDate = this.form.fee
                .map(row => row.date)
                .filter(date => date)
                .sort()
                .pop()

            this.creditDueDate = lastDate || this.creditDueDate
        },
        enterAmount() {
            if (this.paymentMode === 'simple' && this.form.payments.length > 0) {
                this.form.payments[0].payment = Number(this.enter_amount || 0).toFixed(2)
            }
            this.calculateDifference()
        },
        setAmountCash(amount) {
            this.enter_amount = amount
            this.enterAmount()
        },
        calculateDifference() {
            const paid = this.form.payments.reduce((total, row) => {
                return total + Number(row.payment || 0)
            }, 0)

            this.difference = Number((paid - Number(this.form.total || 0)).toFixed(2))
        },
        changeEnabledDiscount() {
            if (!this.enabled_discount) {
                this.discount_amount = 0
            }
            this.inputDiscountAmount()
        },
        inputDiscountAmount() {
            const baseTotal = Number(this.order.total || 0)
            let discount = this.enabled_discount ? Number(this.discount_amount || 0) : 0

            if (!this.is_discount_amount) {
                discount = baseTotal * (discount / 100)
            }

            this.form.total = Number(Math.max(baseTotal - discount, 0).toFixed(2))

            this.creditAmount = this.form.total

            if (this.paymentCondition === 'credit') {
                this.syncCreditFees()
            }

            this.enter_amount = this.form.total

            if (this.paymentMode === 'simple' && this.form.payments.length > 0) {
                this.form.payments[0].payment = this.form.total.toFixed(2)
            }

            this.calculateDifference()
        },
        getDescriptionPaymentMethodType(id) {
            const paymentMethodType = this.payment_method_types.find(row => row.id === id)
            return paymentMethodType ? paymentMethodType.description : ''
        },
        close() {
            this.$emit('update:showDialog', false)
        },
        confirmPayment() {
            const payload = {
                document_type_id: this.form.document_type_id,
                series_id: this.form.series_id,
                customer_id: this.form.customer_id,
                date_of_due: this.paymentCondition === 'credit' ? this.creditDueDate : moment().format('YYYY-MM-DD'),
                payment_condition: this.paymentCondition,
                payment_mode: this.paymentMode,
                credit_mode: this.creditMode,
                reference: this.form.reference_data,
                discount: this.enabled_discount ? Number(this.discount_amount || 0) : 0,
                discount_is_amount: this.is_discount_amount,
                payments: this.paymentCondition === 'cash' ? this.form.payments : [],
                fee: this.paymentCondition === 'credit' ? this.form.fee : [],
                sale_by_consumption: this.saleByConsumption,
                consumption_description: this.consumptionDescription,
            }

            this.loading_submit = true

            this.$http.post(`/${this.resource}/${this.order.id}/generate-document`, payload).then(response => {
                if (response.data.success) {
                    this.$message.success(response.data.message)

                    this.$emit('generated', {
                        id: response.data.data.id,
                        resource: this.form.document_type_id === '80' ? 'sale-notes' : 'documents',
                        document_type_id: this.form.document_type_id,
                    })

                    this.close()
                } else {
                    this.$message.warning(response.data.message)
                }
            }).finally(() => {
                this.loading_submit = false
            })
        },
        changeCustomer() {
            const customer = this.all_customers.find(row => row.id === this.form.customer_id)
            this.customer = customer || null
            this.filterSeries()
        },

        clickDeleteCustomer() {
            this.form.customer_id = null
            this.customer = null
        },

        keyupEnterCustomer() {
            if (this.form.customer_id) {
                return
            }

            if (this.input_person.number) {
                if (!isNaN(parseInt(this.input_person.number))) {
                    switch (this.input_person.number.length) {
                        case 8:
                            this.input_person.identity_document_type_id = '1'
                            this.showDialogNewPerson = true
                            break

                        case 11:
                            this.input_person.identity_document_type_id = '6'
                            this.showDialogNewPerson = true
                            break

                        default:
                            this.input_person.identity_document_type_id = '6'
                            this.showDialogNewPerson = true
                            break
                    }
                }
            }
        },

        keyupCustomer(e) {
            if (e.key !== 'Enter') {
                this.input_person.number = this.$refs.select_person.$el.getElementsByTagName('input')[0].value

                const existPersons = this.all_customers.filter(customer => {
                    return customer.description.search(this.input_person.number) > -1
                })

                this.input_person.number = existPersons.length === 0 ? this.input_person.number : null
            }
        },

        reloadDataCustomers(customer_id) {
            this.$http.get('/pos/table/customers').then(response => {
                this.all_customers = response.data
                this.form.customer_id = customer_id
                this.changeCustomer()
            })
        },

        orderItemDescription(row) {
            if (!row) {
                return ''
            }

            const productDescription =
                row.item && row.item.description
                    ? row.item.description
                    : 'Producto'

            const presentationDescription =
                row.presentation
                    && row.presentation.description
                    ? row.presentation.description
                    : null

            if (!presentationDescription) {
                return productDescription
            }

            return `${productDescription} - ${presentationDescription}`
        },
    },
}
</script>

<style>
.payment-modal-content {
    max-height: none;
    overflow: visible;
    padding-right: 0;
}

.payment-shell {
    max-width: none;
    margin: 0;
}

.payment-main-col {
    max-width: none;
}

.payment-shell .card {
    border: 1px solid #e9edf2;
    border-radius: 12px;
    box-shadow: 0 1px 0 rgba(17, 24, 39, 0.03);
    margin-bottom: 10px;
    background: #ffffff;
}

.payment-shell .card-body {
    padding: 12px 14px;
}

.payment-shell .form-group {
    margin-bottom: 8px;
}

.payment-shell .el-radio-group {
    display: inline-flex;
}

.payment-shell .el-input-number,
.payment-shell .el-date-editor.el-input,
.payment-shell .el-select {
    width: 100%;
}

.payment-shell .btn {
    min-height: 38px;
    border-radius: 8px;
}

.payment-shell .table th,
.payment-shell .table td {
    vertical-align: middle;
}

.payment-shell .control-label {
    font-weight: 600;
    color: #4b5563;
    margin-bottom: 4px;
    font-size: 13px;
}

.payment-shell .el-radio-group {
    gap: 0;
}

.payment-shell h1 {
    margin-top: 2px;
    margin-bottom: 2px;
    font-size: 48px;
    line-height: 1.1;
    color: #374151;
}

.amount-main {
    color: #12a79c;
    font-weight: 800;
}

.pos-payment-dialog .el-dialog__body {
    padding: 8px 10px 12px;
    overflow: visible !important;
}

.pos-payment-dialog .el-dialog {
    border-radius: 12px;
    max-width: 900px;
}

.pos-payment-dialog .el-dialog__header {
    padding: 14px 16px 8px;
    border-bottom: 1px solid #eef2f6;
}

.pos-payment-dialog .el-dialog__title {
    font-weight: 700;
}

.payment-shell .row {
    margin-left: -6px;
    margin-right: -6px;
}

.payment-shell .row>[class*='col-'] {
    padding-left: 6px;
    padding-right: 6px;
}

.payment-shell .el-radio-button__inner {
    min-width: 126px;
    font-weight: 600;
}

.payment-shell .el-radio-button__orig-radio:checked+.el-radio-button__inner {
    background: #12a79c;
    border-color: #12a79c;
}

.quick-cash-btn {
    border-color: #d6dde6 !important;
    color: #5b6676 !important;
    background: #f8fafc !important;
    font-weight: 700;
}

.btn-confirm-pay {
    background: #12a79c;
    border-color: #12a79c;
}

.form-actions-bar {
    border-top: 1px solid #eef2f6;
    padding-top: 10px;
    margin-top: 6px;
}

.btn-outline-danger {
    background: #dc3545 !important;
    border-color: #dc3545 !important;
    color: #fff !important;
}

.c-width {
    margin-right: 0 !important;
    padding: 0 !important;
    width: 80px !important;
}

.c-width-series {
    width: 105px !important;
}

.top-actions {
    min-height: 38px;
    gap: 10px;
}

.btn-back-small {
    min-height: 36px !important;
    padding: 0 14px;
    border-radius: 8px;
}

.card {
    margin-bottom: 2px;
}

.card-body {
    padding: 10px;
}

.h-40 {
    height: 40% !important;
}

.h-60 {
    height: 60% !important;
}

@media (max-width: 991px) {
    .pos-payment-dialog {
        width: 96% !important;
        margin-top: 1vh !important;
    }

    .payment-shell {
        max-width: 100%;
    }

    .payment-main-col {
        max-width: 100%;
    }

    .payment-shell .card-body {
        padding: 10px;
    }

    .payment-shell h1 {
        font-size: 36px;
    }

    .payment-shell .el-radio-button__inner {
        min-width: 90px;
        padding-left: 10px;
        padding-right: 10px;
    }

    .top-actions {
        justify-content: flex-start !important;
        margin-top: 8px;
    }

    .current-order-card {
        min-height: auto;
        margin-top: 14px;
    }
}

.restaurant-summary-shell {
    max-width: none;
}

.current-order-card {
    height: calc(100vh - 175px);
    min-height: 0;
    max-height: 640px;
    background: #ffffff;
    border: 1px solid #e9edf2;
    border-radius: 12px;
    padding: 14px 16px;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    box-shadow: 0 1px 0 rgba(17, 24, 39, 0.03);
}

.current-order-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 14px;
}

.current-order-header h4 {
    margin: 0;
    color: #374151;
    font-size: 22px;
    font-weight: 800;
}

.current-order-header span {
    display: block;
    margin-top: 4px;
    color: #7b8494;
    font-size: 12px;
}

.current-order-icon {
    width: 34px;
    height: 34px;
    border-radius: 8px;
    background: #f8fafc;
    border: 1px solid #e9edf2;
    color: #5b6676;
    display: flex;
    align-items: center;
    justify-content: center;
}

.current-order-consumption {
    margin-bottom: 10px;
    padding: 10px 12px;
    border-radius: 8px;
    background: #f8fafc;
    border: 1px solid #e9edf2;
}

.current-order-consumption .el-checkbox {
    margin-bottom: 0;
    font-weight: 700;
    color: #4b5563;
}

.current-order-consumption .el-checkbox__input.is-checked .el-checkbox__inner {
    background-color: #12a79c;
    border-color: #12a79c;
}

.current-order-consumption .el-checkbox__input.is-checked+.el-checkbox__label {
    color: #12a79c;
}

.current-order-consumption-input {
    margin-bottom: 14px;
    padding: 12px;
    border: 1px solid #e9edf2;
    border-radius: 8px;
    background: #ffffff;
}

.current-order-consumption-input label {
    font-weight: 700;
    color: #4b5563;
    margin-bottom: 6px;
    font-size: 13px;
}

.current-order-items {
    flex: 1 1 auto;
    min-height: 0;
    overflow-y: auto;
    padding-right: 6px;
    margin-right: -6px;
}

.current-order-item {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
    padding: 10px 0;
    border-bottom: 1px solid #eef2f6;
}

.current-order-product strong {
    display: block;
    color: #374151;
    font-size: 13px;
    font-weight: 800;
    line-height: 1.25;
}

.current-order-product span {
    display: block;
    margin-top: 3px;
    color: #7b8494;
    font-size: 12px;
}

.current-order-product small {
    display: block;
    margin-top: 7px;
    color: #12a79c;
    font-size: 12px;
    font-weight: 800;
}

.current-order-quantity {
    min-width: 34px;
    padding-top: 1px;
    color: #7b8494;
    font-size: 12px;
    font-weight: 800;
    text-align: right;
}

.current-order-totals {
    margin-top: 10px;
    padding: 12px;
    background: #f8fafc;
    border: 1px solid #e9edf2;
    border-radius: 8px;
}

.current-order-totals>div {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 5px 0;
}

.current-order-totals span {
    color: #5b6676;
    font-size: 13px;
}

.current-order-totals strong {
    color: #374151;
    font-size: 13px;
    font-weight: 800;
}

.current-order-grand-total {
    margin-top: 10px;
    padding: 12px;
    background: #ffffff;
    border: 1px solid #e9edf2;
    border-radius: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.current-order-grand-total span {
    color: #374151;
    font-size: 20px;
    font-weight: 800;
}

.current-order-grand-total strong {
    color: #374151;
    font-size: 24px;
    font-weight: 900;
}

.restaurant-customer-box {
    display: flex;
    gap: 8px;
    margin-bottom: 10px;
}

.restaurant-customer-select {
    flex: 1;
}

.restaurant-customer-box .el-input__inner {
    height: 38px;
    border-radius: 8px;
    border-color: #d6dde6;
}

.restaurant-customer-button {
    width: 42px;
    height: 38px;
    border-radius: 8px;
    border: 1px solid #d6dde6;
    background: #f8fafc;
    color: #5b6676;
}

.restaurant-customer-button:hover {
    background: #12a79c;
    border-color: #12a79c;
    color: #ffffff;
}

.current-order-header,
.current-order-consumption,
.current-order-consumption-input,
.current-order-totals,
.current-order-grand-total {
    flex-shrink: 0;
}

.current-order-items::-webkit-scrollbar {
    width: 6px;
}

.current-order-items::-webkit-scrollbar-track {
    background: transparent;
}

.current-order-items::-webkit-scrollbar-thumb {
    background: #d6dde6;
    border-radius: 8px;
}

.current-order-items::-webkit-scrollbar-thumb:hover {
    background: #b8c2d1;
}
</style>


// WEBPACK FOOTER //
// modules/Restaurant/Resources/assets/js/views/v2/orders/checkout.vue